export default "__VITE_ASSET__dYPgLrd___"